import React from 'react'

export default function TranslateCategorie() {
  return (
    <div>TranslateCategorie</div>
  )
}
